/**
 * ComplianceIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ComplianceIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m10.94 14.71 3.53-3.54a1.004 1.004 0 0 1 1.42 1.42l-4.24 4.24a1 1 0 0 1-1.42 0l-2.12-2.12a1.004 1.004 0 0 1 1.42-1.42z" />
    <path
      fillRule="evenodd"
      d="M16 3h3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1M5 21h14V5h-3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1H5z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ComplianceIcon = makeIcon('ComplianceIcon', ComplianceIconSvg)
